/*
 * ============================================================
 * ZENZENA – volba „3 balení" bez skutečné varianty
 * ------------------------------------------------------------
 * CO TO DĚLÁ
 * Snippet zenzena-obsah-picker vykreslí řádek „3 balení" jako
 * radio s atributem data-zz3. Není to skutečná varianta: do
 * košíku jde ZÁKLADNÍ varianta × 3 a cenu v košíku srazí
 * automatická sleva. Tenhle soubor to zařídí v prohlížeči:
 *   • po výběru nastaví ve formuláři id základní varianty a
 *     quantity 3, schová výběr množství (CSS pravidlo na
 *     form[data-zz3-on]),
 *   • přepíše ceny (hlavní cenový blok, hlavička quick-buy
 *     modalu, lepivá lišta) hotovými šablonami z pickeru,
 *   • ukáže větu věrnostní nápovědy počítanou s cenou 3 balení,
 *   • po odchodu na jiný řádek vrátí množství na 1.
 *
 * PROČ GLOBÁLNÍ ASSET A DELEGOVANÉ POSLUCHAČE
 * Quick-buy modal (karty v kolekcích i cross-sell v košíku) se
 * plní z fetchnutého HTML produktovky; inline skripty by se tam
 * nespustily. Všechny posluchače proto visí na document.
 *
 * JAK TO SPOLUPRACUJE S MOTIVEM (theme.js, variant-picker)
 *   • Virtuální radio nemá data-option-position, takže ho
 *     <variant-picker> nevidí a nefetchuje neexistující
 *     option_values. Má stejné name jako skutečná radia, takže
 *     skupina zůstává vzájemně vylučující bez dalšího kódu.
 *   • Výběr 3 balení při jiné vybrané variantě: nejdřív se
 *     standardní cestou (synteticky změněné radio základu)
 *     přepne motiv na základní variantu. Motiv po fetchi
 *     překreslí sekci (product:rerender) a pošle variant:change
 *     – ten ale u quick-buy modalu míří na už odpojený formulář,
 *     proto se stav znovu aplikuje z product:rerender (capture
 *     fáze + mikroúloha po dokončení překreslení).
 *   • Stav „3 balení je vybráno" se čte z DOM (je zaškrtnuté
 *     virtuální radio), žádná druhá pravda se neukládá.
 *   • Těsně před odesláním formuláře se id a quantity vynutí
 *     ještě jednou (kdyby fetch selhal nebo ještě běžel).
 *
 * Save as: assets/zenzena-3-baleni.js
 * ============================================================
 */
(function () {
  'use strict';

  if (window.__zenzena3Baleni) return;
  window.__zenzena3Baleni = true;

  var VIRTUAL = 'input[data-zz3]';

  function arr(list) {
    return Array.prototype.slice.call(list);
  }

  function virtualOf(form) {
    return arr(form.elements).filter(function (el) {
      return el.matches && el.matches(VIRTUAL);
    })[0] || null;
  }

  function virtualChecked(form) {
    return arr(form.elements).filter(function (el) {
      return el.matches && el.matches(VIRTUAL + ':checked');
    })[0] || null;
  }

  function idInput(form) {
    return form.querySelector('input[name="id"]');
  }

  /* Skutečné pole množství (ne naše záložní skryté). */
  function qtyInputs(form) {
    return arr(form.elements).filter(function (el) {
      return el.name === 'quantity' && !el.hasAttribute('data-zz3-extra');
    });
  }

  function setId(form, id, notify) {
    var input = idInput(form);
    if (!input || String(input.value) === String(id)) return;
    input.value = id;
    if (notify) input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function setQty(form, n) {
    var inputs = qtyInputs(form);
    var extra = form.querySelector('input[data-zz3-extra]');

    if (!inputs.length) {
      /* Formulář nemá výběr množství (nebo je jinak pojmenovaný):
         quantity doplníme skrytým polem, aby /cart/add dostal 3. */
      if (n > 1) {
        if (!extra) {
          extra = document.createElement('input');
          extra.type = 'hidden';
          extra.name = 'quantity';
          extra.setAttribute('data-zz3-extra', '');
          form.appendChild(extra);
        }
        extra.value = String(n);
      } else if (extra) {
        extra.remove();
      }
      return;
    }

    if (extra) extra.remove();

    inputs.forEach(function (input) {
      var selector = input.closest('quantity-selector');
      var upgraded = selector && typeof selector.restoreDefaultValue === 'function';

      if (n > 1) {
        if (String(input.value) === String(n)) return;
        if (upgraded) {
          selector.quantity = n; /* nastaví hodnotu, změní tlačítka, pošle change */
        } else {
          input.value = String(n);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else if (upgraded) {
        selector.restoreDefaultValue();
      } else {
        input.value = input.defaultValue || '1';
      }
    });
  }

  function swapPrice(target, template) {
    var source = template && template.content && template.content.querySelector('price-list');
    if (!target || !source) return;
    target.replaceWith(source.cloneNode(true));
  }

  function paintPrices(form, radio) {
    var picker = radio.closest('variant-picker');
    var root = form.closest('.quick-buy') || form.closest('.product-info');
    if (!picker || !root) return;

    arr(root.querySelectorAll('price-list')).forEach(function (list) {
      if (list.closest('product-card, .product-cross-sell')) return;
      var kind = list.closest('[data-block-type="price"]') ? 'product' : 'card';
      swapPrice(list, picker.querySelector('template[data-zz3-tpl="' + kind + '"]'));
    });
  }

  function paintSticky(form, radio) {
    var picker = radio.closest('variant-picker');
    var formId = form.getAttribute('id');
    if (!picker || !formId) return;

    var sticky = document.querySelector(
      'product-sticky-add-to-cart[main-product-form="' + CSS.escape(formId) + '"]'
    );
    if (!sticky) return;

    swapPrice(
      sticky.querySelector('price-list'),
      picker.querySelector('template[data-zz3-tpl="line_item"]')
    );

    var title = sticky.querySelector('[data-zz3-sticky-variant]');
    if (title) title.textContent = radio.getAttribute('data-zz3-title') || title.textContent;

    /* Tlačítko na mobilu: „Přidat do košíku · 750 Kč". Text je i v atributech
       animace tlačítka (up-text / rotated-text), jinak by při najetí naskočil starý. */
    var content = sticky.querySelector('.zz3-sticky-cta button-content');
    var price = radio.getAttribute('data-zz3-price-short');
    if (content && price) {
      var head = content.textContent.trim().split(' · ')[0];
      var label = head + ' · ' + price;
      content.textContent = label;
      ['up-text', 'rotated-text'].forEach(function (name) {
        if (content.hasAttribute(name)) content.setAttribute(name, label);
      });
    }
  }

  /* Věrnostní nápověda: dvě věty, druhá (data-zz3-hint) počítá s cenou 3 balení. */
  function paintHint(form, on) {
    var root = form.closest('.product-info');
    if (!root) return;
    arr(root.querySelectorAll('.zzhint')).forEach(function (hint) {
      hint.hidden = hint.hasAttribute('data-zz3-hint') ? !on : on;
    });
  }

  function setUrl(radio) {
    var picker = radio.closest('variant-picker');
    var base = radio.getAttribute('data-zz3-base');
    if (!picker || !picker.hasAttribute('update-url') || !base) return;
    try {
      var url = new URL(window.location.href);
      if (url.searchParams.get('variant') === base) return;
      url.searchParams.set('variant', base);
      window.history.replaceState({ path: url.toString() }, '', url.toString());
    } catch (e) { /* adresa není důležitá */ }
  }

  function apply(form, radio) {
    setId(form, radio.getAttribute('data-zz3-base'), true);
    setQty(form, parseInt(radio.getAttribute('data-zz3-qty'), 10) || 3);
    form.setAttribute('data-zz3-on', '');
    if (!radio.checked) radio.checked = true;
    paintPrices(form, radio);
    paintSticky(form, radio);
    paintHint(form, true);
    setUrl(radio);
  }

  function release(form) {
    if (!form.hasAttribute('data-zz3-on')) return;
    form.removeAttribute('data-zz3-on');
    setQty(form, 1);
  }

  /* Uživatel zaškrtl „3 balení". */
  function onVirtual(radio) {
    var form = radio.form;
    if (!form) return;

    var input = idInput(form);
    var base = radio.getAttribute('data-zz3-base');
    if (input && String(input.value) === String(base)) {
      apply(form, radio);
      return;
    }

    /* Vybraná je jiná varianta: přepnout na základ standardní cestou motivu.
       Stav „3 balení" se doplní v listeneru product:rerender, až motiv
       překreslí sekci; do té doby zůstane zaškrtnuté virtuální radio. */
    if (selectBaseViaTheme(form, radio)) radio.checked = true;
  }

  /* Zaškrtne radio základní varianty a pošle běžné change, na které motiv
     (variant-picker) reaguje fetchem a překreslením. Motiv si hodnoty přečte
     synchronně, takže volající může hned potom zaškrtnout zpět virtuální radio. */
  function selectBaseViaTheme(form, radio) {
    var value = radio.getAttribute('data-zz3-base-value');
    var real = arr(form.elements).filter(function (el) {
      return el.matches && el.matches('input[data-option-position]') && el.value === value;
    })[0];
    if (!real) return false;

    real.checked = true;
    real.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!(target instanceof HTMLInputElement)) return;

    if (target.matches(VIRTUAL)) {
      if (target.checked) onVirtual(target);
    } else if (target.matches('input[data-option-position]') && target.form) {
      /* Jiný řádek: množství zpět na 1 hned, ceny překreslí motiv. */
      release(target.form);
    }
  });

  /* Motiv po výběru varianty vyměnil kus stránky. Formulář (main) zůstává,
     u quick-buy se vymění celý. Stav proto čteme PŘED výměnou (capture fáze,
     událost nebublá, ale capture projde) a znovu ho aplikujeme až po ní. */
  document.addEventListener('product:rerender', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (event.detail && event.detail.productChange) return;

    var formId = form.getAttribute('id');
    var wanted = !!virtualChecked(form);
    var had = form.hasAttribute('data-zz3-on');
    if (!formId || (!wanted && !had)) return;

    queueMicrotask(function () {
      var current = document.getElementById(formId);
      if (!current) return;
      if (wanted) {
        var radio = virtualOf(current);
        if (radio && !radio.disabled) apply(current, radio);
      } else {
        release(current);
      }
    });
  }, true);

  /* Poslední pojistka: ať v košíku skončí vždy základ × 3, i když fetch
     selhal nebo ještě běží. Capture fáze na document jede před posluchačem
     <product-form>, který si z formuláře čte FormData. */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var radio = virtualChecked(form);
    if (!radio) return;
    setId(form, radio.getAttribute('data-zz3-base'), false);
    setQty(form, parseInt(radio.getAttribute('data-zz3-qty'), 10) || 3);
  }, true);

  /* Stránka přišla s ?variant= skutečné 3balení varianty: picker vykreslil
     virtuální řádek zaškrtnutý (data-zz3-init="on") nebo, když je vyprodaný,
     aspoň základ ("base"). Stránka je ale vykreslená pro skutečnou variantu,
     proto se v druhém případě základ vybere standardní cestou motivu (fetch a
     překreslení cen, adresy i lišty). */
  function init() {
    arr(document.querySelectorAll(VIRTUAL + '[data-zz3-init]')).forEach(function (radio) {
      var form = radio.form;
      var mode = radio.getAttribute('data-zz3-init');
      radio.removeAttribute('data-zz3-init');
      if (!form) return;
      if (mode === 'on' && !radio.disabled) apply(form, radio);
      else if (!selectBaseViaTheme(form, radio)) setId(form, radio.getAttribute('data-zz3-base'), true);
    });

    /* Prohlížeč po návratu (tlačítko Zpět bez bfcache) obnoví zaškrtnuté
       virtuální radio, ale ne ceny, lištu ani množství. Kdo je zaškrtnutý
       a ještě nemá aplikovaný stav, dostane ho teď. */
    arr(document.querySelectorAll(VIRTUAL)).forEach(function (radio) {
      var form = radio.form;
      if (!form || !radio.checked || radio.disabled || form.hasAttribute('data-zz3-on')) return;
      apply(form, radio);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Obnova stavu formuláře může proběhnout až po DOMContentLoaded. */
  window.addEventListener('pageshow', init);
  document.addEventListener('shopify:section:load', init);
})();
